const user = [
  { 
    label: "Dashboard", 
    icon: "icon ni ni-growth", 
    url: "/user/dashboard" 
  },
  {
    icon: "icon ni ni-grid-alt",
    label: "Units Setup",
    url: "/user/units",
  },
  {
    label: "Users Setup",
    icon: "icon ni ni-block-over",
    url: "/user/users",
  }, 
  //--------------------------
  {
     label: "Query Form Receivers Setup",
     icon: "icon ni ni-view-x3",
     url: "/user/query_receivers",
  },
  //------------------------
  {
    label: "Voucher Types Setup",
    icon: "icon ni ni-table-view",
    url: "/user/voucher_types",
  },
  //------------------------
  {
     label: "Vouchers Entry",
     icon: "icon ni ni-grid-alt",
     url: "/user/voucher_entry",
  },
  {
     label: "Query Forms Entry",
     icon: "icon ni ni-block-over",
     url: "/user/query_entry",
  },
  //------------------------
  /*{
    label: "Salary Scale Update",
    icon: "icon ni ni-table-view",
    url: "/user/salary_scale_update",
  },
  {
    label: "Payment Voucher Update",
    icon: "icon ni ni-grid-alt",
    url: "/user/payment_voucher",
  },*/
  {
    label: "Audit Voucher Reports",
    icon: "icon ni ni-growth",
    url: "/user/reports",
  },
  /*{
    label: "Payment Voucher Reports",
    icon: "icon ni ni-growth",
    url: "/user/payment_reports",
  },
  {
    label: "Visitors Report",
    icon: "icon ni ni-grid-alt",
    url: "/user/visitor_report",
  },
  {
    label: "Variation Advice",
    icon: "icon ni ni-view-x3",
    url: "/user/variation_advice",
  },*/
];

export default user;
